import { PRIVILEGES } from '../constants';

export const hasPrivilege = (userPrivileges, privilegeToCheck) => {
    // Make sure the privilege to check is a valid one
    if (!Object.values(PRIVILEGES).includes(privilegeToCheck)) {
        return false;
    }

    // Check if the user has the required privilege
    return userPrivileges.some((privilege) => privilege.name === privilegeToCheck);
};

export const isPrivileged = (userPrivileges) => {
    const superPrivileges = Object.values(PRIVILEGES).filter(privilege => privilege.includes("super"));

    return userPrivileges.some(userPrivilege =>
        superPrivileges.includes(userPrivilege.name) || userPrivilege.name.includes(" super"));
};
